import type { NodeMouseHandler } from "@xyflow/react";

/**
 * Hover is one DOM attribute on the React Flow node wrapper, read by CSS
 * (connect handles, chrome reveal, note halo — see canvas-styles.css). No
 * React state: crossing nodes on a busy canvas must not re-render them, and
 * a `.react-flow__node:hover` descendant rule restyles the whole subtree.
 * Every canvas that renders the shared node types must pass both handlers.
 */
export const setNodeHoveredAttribute: NodeMouseHandler = (event) => {
  event.currentTarget.setAttribute("data-hovered", "");
};

export const clearNodeHoveredAttribute: NodeMouseHandler = (event) => {
  event.currentTarget.removeAttribute("data-hovered");
};
